import {WsInsuranceSubscriptionGroupField} from '@lifeislife/lifeislife-ws-api';

export type InsuranceSubscriptionGroupField = WsInsuranceSubscriptionGroupField;
export const InsuranceSubscriptionGroupField = WsInsuranceSubscriptionGroupField;
